import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import _ from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@mui/material";
import StudentRewardCard from "../../Components/Card/StudentRewardCard";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { getAttemptedUniq } from "./Services";
import { Box } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";

const pathToParentMenu = ["root"];

const Rewards = (props) => {
  const navigate = useNavigate();
  const classes = useStyles();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);
  const [completedAssignments, setCompletedAssignments] = useState([]);
  const [completedAssignmentCount, setCompletedAssignmentCount] = useState(0);
  const [cardData, setCardData] = useState([]);

  useEffect(() => {
    let innerFun = async () => {
      let logsData = await getAttemptedUniq(userInfo.site_uuid, userInfo.uid);
      if (logsData.data.length > 0) {
        setCompletedAssignments(logsData.data);
        setCompletedAssignmentCount(
          Math.floor(
            logsData.data.length /
              +process.env.REACT_APP_SELF_LEARN_BADGE_AFTER_NO_COMPLETION
          )
        );
      }
    };
    if (userInfo && siteConfig.customer?.addOnInfo?.isSelfLearning) {
      innerFun();
    }
  }, [userInfo, siteConfig]);

  const selectCurrentReward = () => {
    let data = new Array(+completedAssignmentCount).fill("w");
    data = data.map((val, index) => {
      let slot = index + 1;
      return {
        title: `${
          index * +process.env.REACT_APP_SELF_LEARN_BADGE_AFTER_NO_COMPLETION +
          1
        } to ${
          slot * +process.env.REACT_APP_SELF_LEARN_BADGE_AFTER_NO_COMPLETION
        } Session`,
        description: `For completion of ${
          slot * +process.env.REACT_APP_SELF_LEARN_BADGE_AFTER_NO_COMPLETION
        } sessions`,
      };
    });

    setCardData(data);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Grid
          container
          className={classes.scrollBarHeight}
          sx={{
            flexDirection: "row",
            flexWrap: "nowrap",
            justifyContent: "flex-start",
          }}
        >
          <Grid item xs={5}>
            <Typography
              color="primary.main"
              sx={{
                fontSize: "2rem",
                fontWeight: "bold",
                pl: 10,
                pt: 2,
                "@media (min-width: 1636px)": {
                  fontSize: "3rem",
                },
              }}
            >
              Great Job,{" "}
              {userInfo !== undefined &&
                userInfo !== null &&
                userInfo.name.firstname}
              !
            </Typography>
            {siteConfig && siteConfig.customer?.addOnInfo?.isSelfLearning && (
              <List
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  bgcolor: "background.paper",
                }}
              >
                <ListItem
                  alignItems="flex-start"
                  sx={{ cursor: "pointer" }}
                  onClick={() => {
                    selectCurrentReward();
                  }}
                >
                  <ListItemAvatar>
                    <Avatar alt="Remy Sharp" src={"/thumbbadgh.png"} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={`Punch of ${+process.env
                      .REACT_APP_SELF_LEARN_BADGE_AFTER_NO_COMPLETION}!`}
                    secondary={
                      <React.Fragment>
                        <Typography
                          sx={{ display: "inline" }}
                          component="span"
                          variant="body2"
                          color="text.primary"
                        ></Typography>
                        {`Number of badges you collected on completion of every ${+process
                          .env
                          .REACT_APP_SELF_LEARN_BADGE_AFTER_NO_COMPLETION} sessions`}
                      </React.Fragment>
                    }
                  />
                  <ListItemAvatar>
                    <Avatar
                      sx={{
                        bgcolor: "#edcd0f",
                        color: "#DB8829",
                        fontWeight: "500",
                      }}
                    >
                      <span>{completedAssignmentCount}</span>
                    </Avatar>
                  </ListItemAvatar>
                </ListItem>
                <Divider></Divider>
              </List>
            )}
          </Grid>
          {cardData && cardData.length > 0 && (
            <Grid item xs={7}>
              <Box
                 
                sx={{
                  display: "flex",
                  flexFlow: "wrap",
                  justifyContent: "",
                  mt: 2,
                  gap: 4,
                  height: "80vh",
                  overflow: "auto",
                }}
              >
                {cardData.map((val) => {
                  return (
                    <StudentRewardCard
                      image={"like"}
                      title={val.title}
                      description={val.description}
                    />
                  );
                })}
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
    paddingTop: "1rem",
  },
});
export default Rewards;
